import React, { useContext } from 'react';
import Popup from '../Popup';
import useApi from '../../hooks/useApi';
import { GlobalContext } from '../../GlobalContext';

import { Container, TextBlock } from './styles';

const AnnouncePopup = ({ userToken, loopId, nodeId = null, subType = null, popupIsOpen, onClose, flash = null }) => {
  const context = useContext(GlobalContext);
  const { postData } = useApi(userToken);

  const headerKeyType = nodeId ? subType : 'loop';
  const headerKey = `app_announce_${headerKeyType}`;

  const showFlashMessage = (options) => {
    if (flash) {
      if (typeof options === 'string') {
        flash(options);
      } else {
        flash(options.message, { ttl: options.duration, type: options.type });
      }
    } else {
      context.showFlashMessage(options);
    }
  };

  const contentPanel = (
    <Container>
      <TextBlock
        dangerouslySetInnerHTML={{
          __html: i18n.__('app_announce_body'),
        }}
      />
    </Container>
  );

  const onClick = async () => {
    const baseUrl = `/editor/${loopId}`;
    const nodePart = nodeId ? `/node/${nodeId}` : '';
    const endpoint = `${baseUrl}${nodePart}/announce`;

    const result = await postData(endpoint);
    if (result.success) {
      showFlashMessage({
        message: i18n.__('app_success'),
        duration: 3000,
        type: 'status',
      });
      onClose();
    } else {
      console.error(result);
      showFlashMessage(i18n.__('app_error_alert'));
    }
  };

  return (
    <Popup
      popupIsOpen={popupIsOpen}
      heading={i18n.__(headerKey)}
      id="announce-popup"
      contentPanel={contentPanel}
      buttonLabel={i18n.__('app_send')}
      onClose={onClose}
      onClick={onClick}
    />
  );
};

export default AnnouncePopup;
